import { message } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const useGetUserLocation = () => {
  const { t } = useTranslation();
  const [loc, setLoc] = useState<any>();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        setLoc({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
      },
      (e) => {
        const isMessageShown = localStorage.getItem('isMessageShown');
        if (!isMessageShown) {
          localStorage.setItem('isMessageShown', 'true');
          message.error(t('common.allowLocationAccess'));
        }
        setError(e.message);
      },
    );
  }, []);

  return { error, location: loc };
};

export default useGetUserLocation;
